
































import { defineComponent, onMounted, onUnmounted } from '@vue/composition-api'
import { useI18n, useRouter } from 'phoenix'
import { UserSessionTimeoutService } from './services/UserSessionTimeoutService'

export default defineComponent({
  name: 'App',
  setup () {
    const { t } = useI18n()
    const toolbarItems = [{ title: t('home'), href: 'https://www.mijnpgb.nl/', icon: '$icon-homepage' }]
    const footerLinks = [
      { url: 'https://www.mijnpgb.nl/privacy', label: t('privacy') },
      { url: 'https://www.mijnpgb.nl/cookies', label: t('cookiePolicy') },
      { url: 'https://www.mijnpgb.nl/toegankelijkheid', label: t('accessibility') },
    ]
    const { router } = useRouter()

    const signout = async () => {
      router.push({ name: 'Logout' })
    }

    const userSessionTimoutMilliseconds = 15 * 60 * 1000 // 15 minuten
    const userSessionTimeoutService = new UserSessionTimeoutService(
      window,
      signout,
      userSessionTimoutMilliseconds
    )

    onMounted(() => {
      userSessionTimeoutService.startOrRestart()
    })
    onUnmounted(() => {
      userSessionTimeoutService.stop()
    })

    router?.beforeEach((to: { path: string; }, _from: any, next: () => void) => {
      if (to.path.startsWith('/login')) {
        userSessionTimeoutService.suspended = true
      } else {
        userSessionTimeoutService.suspended = false
      }
      next()
    })
    return { toolbarItems, footerLinks, signout }
  },
})
